import React, { useContext } from "react";
import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";

interface ActiveNoteEditIconProps {
  fill?: string;
  width?: string;
  height?: string;
  isActive?: boolean;
}

const ActiveNoteEditIcon: React.FC<ActiveNoteEditIconProps> = ({
  fill,
  width = "32px",
  height = "29px",
  isActive = false,
}) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalFill = fill?.trim() ? fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132e";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter={isActive ? "url(#filter0_dddd_active_note_edit_icon)" : undefined}>
        <path
          d="M13.9037 23H9.8411C9.82891 23 9.80942 23 9.78504 22.9988C8.37642 22.9805 7.05919 22.2143 6.34208 20.9963L2.56159 14.5653C1.8128 13.2912 1.8128 11.7082 2.56159 10.4347L6.34208 4.00427C7.06894 2.76801 8.40993 2 9.8411 2H17.5197C18.9508 2 20.2918 2.76801 21.0187 4.00366L21.8838 5.47497C22.0886 5.82357 21.9728 6.27289 21.6249 6.47802C21.277 6.68376 20.8286 6.56715 20.6239 6.21856L19.7587 4.74725C19.2939 3.95604 18.4354 3.46459 17.5197 3.46459H9.8411C8.92537 3.46459 8.06692 3.95604 7.60205 4.74725L3.82155 11.1777C3.34206 11.9927 3.34206 13.0061 3.82155 13.8211L7.60205 20.2515C8.06265 21.0348 8.91136 21.5256 9.81673 21.533H9.85389L13.9037 21.5336C14.3076 21.5336 14.6348 21.8614 14.6348 22.2662C14.6348 22.6709 14.3076 22.9988 13.9037 22.9988V23Z"
          fill={finalFill}
        />
        <path
          d="M16.2463 22.9676C16.1165 22.9676 15.9873 22.9328 15.8734 22.8651C15.687 22.754 15.559 22.5659 15.5243 22.351L14.8675 18.2534C14.8407 18.0842 14.8736 17.9109 14.9607 17.7637L20.7085 8.04701C21.6596 6.43956 23.7378 5.9072 25.3414 6.86019C26.1182 7.32173 26.6696 8.05861 26.8932 8.93529C27.1168 9.81196 26.9864 10.7234 26.5258 11.5024L20.778 21.2192C20.6908 21.3663 20.555 21.4786 20.3941 21.536L16.4912 22.9255C16.4114 22.9536 16.3291 22.9676 16.2463 22.9676ZM16.3535 18.2827L16.8293 21.2503L19.6557 20.2442L25.2689 10.7558C25.5302 10.3138 25.6046 9.7967 25.4772 9.29914C25.3499 8.80159 25.0374 8.38339 24.5962 8.12149C24.1551 7.85958 23.6391 7.78571 23.1425 7.9127C22.646 8.03968 22.2286 8.35348 21.9673 8.79548L16.3541 18.2839L16.3535 18.2827Z"
          fill={finalFill}
        />
        <path
          d="M17.1352 9.76928H8.73527C8.33133 9.76928 8.00415 9.44144 8.00415 9.03668C8.00415 8.63192 8.33133 8.30408 8.73527 8.30408H17.1352C17.5392 8.30408 17.8663 8.63192 17.8663 9.03668C17.8663 9.44144 17.5392 9.76928 17.1352 9.76928Z"
          fill={finalFill}
        />
        <path
          d="M15.1441 13.3547H8.73527C8.33133 13.3547 8.00415 13.0269 8.00415 12.6221C8.00415 12.2174 8.33133 11.8895 8.73527 11.8895H15.1441C15.5481 11.8895 15.8753 12.2174 15.8753 12.6221C15.8753 13.0269 15.5481 13.3547 15.1441 13.3547Z"
          fill={finalFill}
        />
        <path
          d="M12.986 16.9396H8.80827C8.40432 16.9396 8.07715 16.6117 8.07715 16.207C8.07715 15.8022 8.40432 15.4744 8.80827 15.4744H12.986C13.3899 15.4744 13.7171 15.8022 13.7171 16.207C13.7171 16.6117 13.3899 16.9396 12.986 16.9396Z"
          fill={finalFill}
        />
        <path
          d="M25.013 13.3547C24.8936 13.3547 24.7723 13.3254 24.6602 13.2638L20.0164 10.6972C19.663 10.5019 19.5345 10.0562 19.7295 9.70212C19.9244 9.34803 20.3692 9.21921 20.7226 9.41457L25.3664 11.9811C25.7198 12.1765 25.8483 12.6221 25.6533 12.9762C25.5199 13.2186 25.2701 13.3554 25.0124 13.3554L25.013 13.3547Z"
          fill={finalFill}
        />
      </g>

      {isActive && (
        <defs>
          <filter
            id="filter0_dddd_active_note_edit_icon"
            x="0"
            y="0"
            width="28.9998"
            height="25"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_active_note_edit_icon"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_active_note_edit_icon"
              result="effect2_dropShadow_active_note_edit_icon"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_active_note_edit_icon"
              result="effect3_dropShadow_active_note_edit_icon"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_active_note_edit_icon"
              result="effect4_dropShadow_active_note_edit_icon"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect4_dropShadow_active_note_edit_icon"
              result="shape"
            />
          </filter>
        </defs>
      )}
    </svg>
  );
};

export default ActiveNoteEditIcon;
